module.exports = __webpack_public_path__ + "static/media/broken-shield.c26ddd72.svg";